var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTileViewRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63232 22.7029H15.6323C20.6323 22.7029 22.6323 20.7029 22.6323 15.7029V9.70288C22.6323 4.70288 20.6323 2.70288 15.6323 2.70288H9.63232C4.63232 2.70288 2.63232 4.70288 2.63232 9.70288V15.7029C2.63232 20.7029 4.63232 22.7029 9.63232 22.7029Z",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6323 2.70288V22.7029",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6323 12.7029H22.6323",
    stroke: "#fff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8662 0.866211C21.3544 0.378056 22.1456 0.378055 22.6338 0.866211C23.1219 1.35437 23.1219 2.14565 22.6338 2.63379L2.63379 22.6338C2.14565 23.1219 1.35437 23.1219 0.866211 22.6338C0.378055 22.1456 0.378056 21.3544 0.866211 20.8662L20.8662 0.866211Z",
    fill: "#fff",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileViewRemove);
export default __webpack_public_path__ + "static/media/tileViewRemove.1dba1da55ef28fc7dd2d75b93df42063.svg";
export { ForwardRef as ReactComponent };